import { Navigate, useParams } from 'react-router-dom';
import { editorPrimaryShort } from '@/lib/editorPairs';
import { messageWorkspaceHref } from '@/lib/messageWorkspace';

/** Legacy /try → message workspace edit mode. */
export function TryRedirect() {
  return <Navigate to={messageWorkspaceHref('pacs.008', { mode: 'edit' })} replace />;
}

/** Legacy /try/:short → message workspace edit mode (pair → primary). */
export function TryShortRedirect() {
  const { short } = useParams();
  const raw = (short ?? 'pacs.008').replace(/-/g, '.');
  const primary = editorPrimaryShort(raw);
  return <Navigate to={messageWorkspaceHref(primary, { mode: 'edit' })} replace />;
}
